export default "__VITE_ASSET__RSd6zi9w__"